<style lang="less" src="./containers.less" scoped></style>
<template>
  <div class="containers" :style="styleCss">
    <Headers :goBack="goBack" v-if="isShowHeader"/>
    <div class="contexts" :style="contexts">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import Headers from "@roots/pLibrary/layout/Header/headers.vue";
export default {
  data() {
    return {};
  },
  components: {
    Headers
  },
  props: {
    isShowHeader: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    goBack: {
      type: Object,
      default: () => {}
    },
    contexts: {
      type: Object,
      default: () => {}
    },
    styleCss: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
